var trigger = document.querySelector('.mobileMenu');
var mobileMenu = document.getElementById('mobileMenu')

trigger.addEventListener('click', function() {
    mobileMenu.classList.toggle('mobileMenuWrapper--open')
})

var mobileMenuItems = mobileMenu.querySelectorAll('.mainNav__item')

for ( var i = 0; i < mobileMenuItems.length; i++ ) {
    var obj = mobileMenuItems[ i ];
    if(obj.classList.contains('js-scroller')) {
        obj.addEventListener('click', function() {
            mobileMenu.classList.toggle('mobileMenuWrapper--open')
        })
    }
}

var mobileMenuCloseTrigger = document.querySelectorAll('.js-closeMenu')

mobileMenuCloseTrigger[1].addEventListener('click', function() {
    console.log('wfwef')
    mobileMenu.classList.toggle('mobileMenuWrapper--open')
})